import { useSetAtom } from "jotai";
import { useReactFlow } from "@xyflow/react";
import {
  edgesAtom,
  nodesAtom,
  startStreamingProgressAtom,
} from "@zapier/canvas-state";
import { handleCloseModalCommand } from "../atoms/handleCloseModalCommand";
import { usePromptToZslToCanvas } from "./usePromptToZslToCanvas";

export function useStreamingPrompt() {
  const { onPromptSubmit } = usePromptToZslToCanvas();
  const handleCloseModal = useSetAtom(handleCloseModalCommand);
  const setNodes = useSetAtom(nodesAtom);
  const setEdges = useSetAtom(edgesAtom);
  const startProgressAnimation = useSetAtom(startStreamingProgressAtom);
  const { setViewport } = useReactFlow();

  const submitPrompt = (args: any) => {
    onPromptSubmit(args);
    handleCloseModal();
    setNodes([]);
    setEdges([]);
    setViewport({ x: 0, y: 0, zoom: 1 });
    startProgressAnimation();
    return args;
  };

  return { submitPrompt };
}
